/** Sitzungslogik für versteckte Easter Eggs. Keine Fachdaten, kein Speicher auf dem Server. */

export const KONAMI_SEQUENCE = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a',
] as const;

export const COFFEE_QUERY = 'cvss:coffee';
export const VERSION_CLICKS_TO_UNLOCK = 7;
export const DEV_MODE_ACCENT = '#ff4fd8';
export const DEV_MODE_LABEL = 'Operation Kaffeefilter';
export const KONAMI_TOAST = 'Access granted. Scope: Kaffeeküche.';

export function normalizeKonamiKey(key: string): string {
  return key.length === 1 ? key.toLowerCase() : key;
}

export function advanceKonami(index: number, key: string): { index: number; matched: boolean } {
  const normalized = normalizeKonamiKey(key);
  if (normalized === KONAMI_SEQUENCE[index]) {
    const next = index + 1;
    if (next === KONAMI_SEQUENCE.length) {
      return { index: 0, matched: true };
    }
    return { index: next, matched: false };
  }
  if (normalized === KONAMI_SEQUENCE[0]) {
    return { index: 1, matched: false };
  }
  return { index: 0, matched: false };
}

export function shouldIgnoreKonamiTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
  return Boolean(target.isContentEditable);
}

export function isCoffeeQuery(value: string): boolean {
  return value.trim().toLowerCase() === COFFEE_QUERY;
}

export function nextVersionClicks(current: number): { clicks: number; unlocked: boolean } {
  const clicks = current + 1;
  if (clicks >= VERSION_CLICKS_TO_UNLOCK) {
    return { clicks: 0, unlocked: true };
  }
  return { clicks, unlocked: false };
}

export function aprilDismissStorageKey(userId: number, year: number): string {
  return `stark-aprilscherz-dismissed:${userId}:${year}`;
}

export function isAprilDismissed(userId: number, year: number): boolean {
  try {
    return localStorage.getItem(aprilDismissStorageKey(userId, year)) === '1';
  } catch {
    return false;
  }
}

export function dismissApril(userId: number, year: number): void {
  localStorage.setItem(aprilDismissStorageKey(userId, year), '1');
}
